import React from 'react'
import './footer.less'
import Logo from '../../images/Logo.png'
import {FaFacebookSquare, FaInstagramSquare, FaWhatsappSquare} from 'react-icons/fa'

export default ()=>{
    return(
        <section className="footer">
            <article className="footer-container">
                <div className="logo">
                    <img src={Logo} alt="" />
                    <h4>The empower initiative</h4>
                    <p>investing in humanity</p>
                </div>
                <div className="quick-links">
                    <h4>quick links</h4>
                    <p><a href="">about us</a></p>
                    <p><a href="">events</a></p>
                    <p><a href="">blog</a></p>
                    <p><a href="">contact us</a></p>
                </div>
                <div className="reach-us">
                    <h4>reach us on</h4>
                    <article className="social">
                        <span>
                            <a href="https://www.facebook.com/The-Empower-Initiative-105256254781938/">
                                <FaFacebookSquare/>
                            </a>
                        </span>
                        <span>
                            <a href="https://instagram.com/theempowerinitiative.sl?igshid=1ciqeouqyxy6l">
                                <FaInstagramSquare/>
                            </a>
                        </span>
                        <span>
                            <a href="https://wa.me/+94778760802">
                                <FaWhatsappSquare/>
                            </a>
                        </span>
                    </article>
                </div>
            </article>
        </section>
    )
}